var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 17.5C6.015 17.5 5.68542 17.3654 5.41125 17.0961C5.13708 16.8268 5 16.5031 5 16.125V7.875C5 7.49687 5.13708 7.17318 5.41125 6.90391C5.68542 6.63464 6.015 6.5 6.4 6.5H17.6C17.985 6.5 18.3146 6.63464 18.5887 6.90391C18.8629 7.17318 19 7.49687 19 7.875V16.125C19 16.5031 18.8629 16.8268 18.5887 17.0961C18.3146 17.3654 17.985 17.5 17.6 17.5H6.4ZM6.4 16.125H17.6V7.875H6.4V16.125ZM11.3 15.4375H16.9V11.3125H11.3V15.4375ZM12.7 14.0625V12.6875H15.5V14.0625H12.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDisplay);
export default __webpack_public_path__ + "static/media/check_display.a6d0e058548bd770112c9141be3ca11e.svg";
export { ForwardRef as ReactComponent };